import { MAIN_URL, Subdomains, ReplaceParams, UserEndpoints, PublicEndpoints } from "../constants";
import type {
  RegisterData,
  TokenDataPayload,
  AuthenticateData,
  RegistrationPayload,
  CheckStatusDataRegNum,
  ValidateUserRegNumData,
  CheckStatusDataIsraeliId,
  ValidateUserIsraeliIdData,
  ValidateUserRegNumPayload,
  ValidateUserIsraeliIdPayload,
} from "../types";
import axios from "axios";

axios.defaults.withCredentials = true;

export async function getAppInfo() {
  return await axios<PublicEndpoints.info>({
    method: "GET",
    url: `${MAIN_URL}`,
  });
}

export async function getTokenData(token: string) {
  return await axios<TokenDataPayload>({
    method: "GET",
    url: `${MAIN_URL}${PublicEndpoints.portal}?token=${token}`,
  });
}

export async function checkStatusRegNum(checkStatusData: CheckStatusDataRegNum) {
  return await axios<{ status: string }>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.statusCheckRegNum}`
      .replace(ReplaceParams.registrationNumber, String(checkStatusData.registrationNumber))
      .replace(ReplaceParams.birthDate, checkStatusData.birthDate)
      .replace(ReplaceParams.language, checkStatusData.language),
  });
}
export async function checkStatusIsraeliId(checkStatusData: CheckStatusDataIsraeliId) {
  return await axios<{ status: string }>({
    method: "GET",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.statusCheckIsraeliId}`
      .replace(ReplaceParams.israeliId, String(checkStatusData.israeliId))
      .replace(ReplaceParams.birthDate, checkStatusData.birthDate)
      .replace(ReplaceParams.language, checkStatusData.language),
  });
}

export async function validateUserByRegNum(validateUserData: ValidateUserRegNumData) {
  return await axios<ValidateUserRegNumPayload>({
    method: "POST",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.validationByRegNum}`,
    data: validateUserData,
  });
}

export async function validateUserByIsraeliId(validateUserData: ValidateUserIsraeliIdData) {
  return await axios<ValidateUserIsraeliIdPayload>({
    method: "POST",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.validationByIsraeliId}`,
    data: validateUserData,
  });
}

export async function registerUser(registerData: RegisterData) {
  return await axios<RegistrationPayload>({
    method: "POST",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.registration}`,
    data: registerData,
  });
}

export async function authenticateUser(authenticateData: AuthenticateData) {
  return await axios<RegistrationPayload>({
    method: "POST",
    url: `${MAIN_URL}${Subdomains.users}${UserEndpoints.authentication}`,
    data: authenticateData,
  });
}
